/**
 * <dtf-catbar> — モバイルのカテゴリースライダー。横スクロール位置に応じて進捗バーを更新。
 */
class DtfCatbar extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;

    this._initialized = true;
    this.track = this.querySelector('[data-scroll]');
    this.thumb = this.querySelector('[data-thumb]');
    if (!this.track || !this.thumb) return;

    this._update = () => {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => {
        this._frame = null;
        this.update();
      });
    };
    this.track.addEventListener('scroll', this._update, { passive: true });
    window.addEventListener('resize', this._update);
    this.update();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this._update);
    window.removeEventListener('resize', this._update);
    if (this._frame) cancelAnimationFrame(this._frame);
    this._frame = null;
    this._initialized = false;
  }

  update() {
    const el = this.track;
    const sw = el.scrollWidth;
    const cw = el.clientWidth;
    const widthPct = cw >= sw ? 100 : Math.max(16, (cw / sw) * 100);
    const max = Math.max(0, sw - cw);
    const leftPct = max > 0 ? (el.scrollLeft / max) * (100 - widthPct) : 0;
    this.thumb.style.width = `${widthPct}%`;
    this.thumb.style.left = `${leftPct}%`;
  }
}

if (!customElements.get('dtf-catbar')) {
  customElements.define('dtf-catbar', DtfCatbar);
}
